import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HashLoader } from "react-spinners";
import * as api from "../api/index";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [loading, setLoading] = useState(false);

  async function Submit(e) {
    e.preventDefault();
    if (email !== "" && password !== "") {
      setLoading(true);

      try {
        const { data } = await api.Login({ email, password });
        if (data.success) {
          setThemeColor("themeGreen");
          setMessage(data.message);
          localStorage.setItem("user_info", JSON.stringify(data));
          window.location.href = "/";
        } else {
          setThemeColor("themeRed");
          setMessage(data.message);
        }
        setLoading(false);
      } catch (err) {
        alert(err);
      }
    }
  }

  return (
    <div>
      {loading ? (
        <HashLoader size={150} color={"#2A25EC"} loading={loading}></HashLoader>
      ) : (
        <form className="loginContainer" action="POST">
          <div className="loginContainerv2">
            <h1>Welcome back</h1>
            {message ? <p className={themeColor}>{message}</p> : <p></p>}
            <div className="inputContainer">
              <label>EMAIL</label>
              <input
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email or username"
                type="text"
                autoComplete="username"
              />
            </div>

            <div className="inputContainer">
              <label>PASSWORD</label>
              <input
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                type="password"
                autoComplete="current-password"
              />
            </div>

            {/* <div className="forgetmeContainer">
          <div>
            <Link to="/account/forgotpassowrd">Forgot password?</Link>
          </div>
        </div> */}

            <button className="loginBTN" onClick={Submit}>
              LOGIN
            </button>

            <span className="notreg">
              <strong>Not registered yet? </strong>
              <Link className="singupBTN" to="/account/register">
                Signup
              </Link>
            </span>
          </div>
        </form>
      )}
    </div>
  );
}

export default Login;
